import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContainerMarginFormComponent } from './container-margin-form/container-margin-form.component';
import { ContainerMarginWindowComponent } from './container-margin-window/container-margin-window.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    data: {
      title: 'Container Margin Window'
    },
    component: ContainerMarginWindowComponent
    // component: ContainerMarginFormComponent
  },
  {
    path: 'add',
    data: {
      title: 'Add Container Margin'
    },
    component: ContainerMarginFormComponent
  },
  {
    path: 'edit/:id',
    data: {
      title: 'Edit Container Margin'
    },
    component: ContainerMarginFormComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ContainerMarginRoutingModule { }
